/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import { useEffect, useMemo, useCallback } from 'react';

import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import queryString from 'query-string';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { ResponsiveComponent } from '../../utils/functions';
import Sidebar from '../../components/Sidebar';
import { plusicon, refreshicon } from '../../components/imagepath';
import Header from '../../components/Header';
import AdvancedTable from '../../components/AdvancedTable';
import { ActionGetRoomPricesList, ActionDeleteRoomPrice } from '../../store/Actions/RoomPriceAction';
const { confirm } = Modal;

const RoomPriceTable = () => {
    const { loader, roomPrices } = useSelector(state => state?.RoomPrices);
    const { userDetails } = useSelector(state => state?.auth);
    const [showArrow, setShowArrow] = useState(true);
    const [Refresh, setRefresh] = useState(false);
    const [arrowAtCenter, setArrowAtCenter] = useState(false);
    const pageSize = 10;
    const dispatch = useDispatch();
    const location = useLocation();
    const params = queryString.parse(location.search);
    const Size = ResponsiveComponent();
    const mergedArrow = useMemo(() => {
        if (arrowAtCenter)
            return {
                pointAtCenter: true,
            };
        return showArrow;
    }, [showArrow, arrowAtCenter]);


    const content = item => (
        <div className="">
            <Button className="m-2" onClick={() => EditList(item?.id)}>
                Edit
            </Button>
            <Button onClick={() => showDeleteConfirm(item)}>Delete</Button>
        </div>
    );

    // Define columns for AdvancedTable
    const columns = [
        {
            id: 'sr',
            name: 'Sr',
            selector: 'sr',
            sortable: false,
            cell: (record, index) => {
                const currentPage = parseInt(params?.page) || 1;
                const calculatedIndex = (currentPage - 1) * pageSize + index + 1;
                return <span>{calculatedIndex}</span>;
            },
        },
        {
            id: 'roomTypeId',
            name: 'Room Type',
            selector: row => row.roomTypeId?.code || '',
            cell: (record, index) => {
                return <span>{record.roomTypeId?.code}</span>;
            },
            sortable: true,
        },
        {
            id: 'occupancyModeId',
            name: 'Occupancy Mode',
            selector: row => row.occupancyModeId?.code || '',
            cell: (record, index) => {
                return <span>{record.occupancyModeId?.code}</span>;
            },
            sortable: true,
        },
        {
            id: 'pricePerDay',
            name: 'Price Per Day',
            selector: row => row.pricePerDay || '',
            cell: (record, index) => {
                return <span>{record.pricePerDay}</span>;
            },
            sortable: true,
        },
        {
            id: 'perDayPriceForCaretaker',
            name: 'Caretaker Price',
            selector: row => row.perDayPriceForCaretaker || '',
            cell: (record, index) => {
                return <span>{record.perDayPriceForCaretaker || '-'}</span>;
            },
            sortable: true,
        },
        {
            id: 'currency',
            name: 'Currency',
            selector: row => row.currency || '',
            cell: (record, index) => {
                return <span>{record.currency}</span>;
            },
            sortable: true,
        }
    ];

    // Add actions column only if user has update or delete permissions
    // if (canUpdate || canDelete) {
    // columns.push({
    //     id: 'actions',
    //     name: 'Action',
    //     selector: 'id',
    //     sortable: false,
    //     cell: (record) => (
    //         <Popover
    //             placement="left"
    //             title={record.title}
    //             content={() => content(record)}
    //             arrow={mergedArrow}
    //         >
    //             <Button type="dashed">• • •</Button>
    //         </Popover>
    //     ),
    // });
    // }

    useEffect(() => {
        // Dispatch action to fetch room types list
        dispatch(ActionGetRoomPricesList({ Query: `?page=${params?.page || 1}` }));
        setRefresh(false);
    }, [dispatch, params?.page, Refresh]);

    const handleSearch1 = searchTerm => {
        var newp = params;
        newp.page = searchTerm;
        window.location.href = window.location.pathname + '?' + queryString.stringify(newp);
    };

    const EditList = searchTerm => {
        window.location.href = `/room-types/add-room-type?update=true&&id=${searchTerm}&&page=${parseInt(params.page)}`;
    };

    const showDeleteConfirm = item => {
        confirm({
            title: `Are you sure delete this ${item?.id}?`,
            icon: <ExclamationCircleFilled />,
            content: '',
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            zIndex: 1200,
            centered: true,
            onOk() {
                dispatch(
                    ActionDeleteRoomPrice('/' + item?.id, Res => {
                        if (Res === 200) {
                            setRefresh(true);
                        }
                    })
                );
            },
            onCancel() {

                return
            },
        });
    };

    // fetchData function for AdvancedTable
    const fetchData = useCallback(async (params) => {
        return {
            data: roomPrices?.docs || [],
            total: roomPrices?.totalDocs || 0,
        };
    }, [roomPrices]);

    return (
        <>
            <Header />
            <Sidebar />
            <>
                <div>
                    <div className="page-wrapper">
                        <div className="content">
                            {/* Page Header */}
                            <div className="page-header">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <ul className="breadcrumb">
                                            <li className="breadcrumb-item">
                                                <Link to="/room-prices">prices</Link>
                                            </li>
                                            <li className="breadcrumb-item">
                                                <i className="feather-chevron-right">
                                                    <FeatherIcon icon="chevron-right" />
                                                </i>
                                            </li>
                                            <li className="breadcrumb-item active">prices List</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* /Page Header */}
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card card-table show-entire">
                                        <div className="card-body">
                                            {/* Table Header */}
                                            <div className="page-table-header mb-2">
                                                <div className="row align-items-center">
                                                    <div className="col">
                                                        <div className="doctor-table-blk">
                                                            <h3>prices List</h3>
                                                            <div className="doctor-search-blk">
                                                                <div className="add-group">

                                                                    <Link
                                                                        to="/room-prices/add-room-prices"
                                                                        className="btn btn-primary add-pluss ms-2"
                                                                    >
                                                                        <img src={plusicon} alt="#" />
                                                                    </Link>



                                                                    <Link
                                                                        onClick={() => window.location.reload()}
                                                                        className="btn btn-primary doctor-refresh ms-2"
                                                                    >
                                                                        <img src={refreshicon} alt="#" />
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* /Table Header */}
                                            <AdvancedTable
                                                resource="room-type"
                                                columns={columns}
                                                fetchData={fetchData}
                                                loading={loader}
                                                enableSearch={true}
                                                enableFilters={true}
                                                enableExport={false}
                                                enableRefresh={false}
                                                enableColumnManager={true}
                                                enableBulkActions={false}
                                                enableSummary={false}
                                                enableSelection={false}
                                                defaultPageSize={10}
                                                onRowClick={(record) => {
                                                    // Optional: handle row click
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </>
    );
};

export default RoomPriceTable;